import { useState, useEffect } from 'react';
import { Modal, TextField, Banner, DescriptionList } from '@shopify/polaris';
import { formatToCurrency, putRequest } from '../../../shared/components/functions';
import { performTracking } from '../../../analytics/segment';

export default function CreditnoteCollection({ modalOpen, setModalOpen, fullInvoiceCollection, collectionInvoice, fetchData }) {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setState({
      BedragOpen: fullInvoiceCollection ? 0 : Math.round(collectionInvoice.BedragOpen * 100) / 100,
      CreditnotaID: collectionInvoice.CreditnotaID,
      Opmerking: collectionInvoice.Opmerking,
      Verstuurd: fullInvoiceCollection ? 1 : collectionInvoice.Verstuurd,
      Betaald: fullInvoiceCollection ? 1 : collectionInvoice.Betaald,
      partiallyPaid: 0
    });
    //eslint-disable-next-line
  }, [collectionInvoice]);

  const handleChange = (value, id) => {
    if (id === 'partiallyPaid') {
      setState((state) => ({ ...state, BedragOpen: collectionInvoice.BedragOpen - Math.round(parseFloat(String(value).replace(',', '.')) * 100) / 100 }));
    }
    setState((state) => ({ ...state, [id]: value }));
  };

  const collectInvoice = async () => {
    setLoading(true);
    await putRequest(`/api/creditnotes/${state.CreditnotaID}`, state);
    setModalOpen(false);
    setLoading(false);
    await fetchData();
    if (fullInvoiceCollection) {
      performTracking('payment_collected_creditnote_full', state);
    } else {
      performTracking('payment_collected_creditnote_partial', state);
    }
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={`Payment credit note #${collectionInvoice.Creditnotanummer}`}
        primaryAction={{
          content: fullInvoiceCollection ? 'Mark as fully paid' : 'Mark as partially paid',
          onAction: () => collectInvoice(),
          loading: loading
        }}
        secondaryActions={[{ content: 'Cancel', onAction: () => setModalOpen(false) }]}
      >
        <Modal.Section>
          {fullInvoiceCollection ? (
            <Banner tone="info">The invoice status will be automatically set to paid. And the open amount to 0.</Banner>
          ) : (
            <Banner tone="warning">The invoice status will not be set to paid. Please set the remaining open value yourself.</Banner>
          )}
          <br />
          <DescriptionList
            items={[
              {
                term: 'Credit note number',
                description: `#${collectionInvoice.Creditnotanummer}`
              },
              {
                term: 'Credit note reference',
                description: collectionInvoice.Referentie
              },
              {
                term: 'Company',
                description: collectionInvoice.customer_name
              },
              {
                term: 'Total value',
                description: formatToCurrency(collectionInvoice.BedragTotaal)
              }
            ]}
          />
          <br />
          <br />
          {!fullInvoiceCollection && (
            <>
              <TextField
                prefix="€"
                id="partiallyPaid"
                disabled={fullInvoiceCollection}
                type="currency"
                label="AMOUNT THAT IS PARTIALLY PAID"
                value={String(state.partiallyPaid)}
                onChange={handleChange}
              />
              <br />
            </>
          )}
          <TextField id="BedragOpen" disabled type="number" prefix="€" label="Open amount" value={String(state.BedragOpen)} onChange={handleChange} />
          <br />
          <TextField multiline={5} id="Opmerking" label="Note" value={state.Opmerking} onChange={handleChange} />
          <br />
        </Modal.Section>
      </Modal>
    </div>
  );
}
